<template>
  <v-card flat class="ma-0 pl-5 pr-5 pt-5 round-0 " >
    <v-card-text class="pa-0 pl-2">
      <div v-for="ad in ads" :key="ad.id" class="pointer mb-2">
        <a :ref="'side_add_'+ad.id" :href="ad.navigation_url" target="_blank" > </a>
        <v-img
          @click="on_click_advert(ad)"
          :src="ad.media_url"
          max-height="280"
          contain
          color="white"
          class="grey darken-4 pa-0 ma-0 "
        ></v-img>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import ServerClient from "./../lib/ServerClient"
export default {
  name: "HomeSideAdsContainer",
  props: {
    side: {
      type: String,
      default: "left",
    },
    page:{
      type: String,
      default: ""
    },
    number_of_ads: {
      type: Number,
      default:1
    }
  },
  data: () => ({
    ads: [],
  }),
  mounted() {
    ServerClient.Adverts.load_adverts({
      page: this.page,
      section: this.side,
      number_of_ads_to_load: this.number_of_ads
    },(res) => {
      this.ads = res;
    }, (errors) => {
      console.log("HomeSideAdsContainer: Errors while loading adverts on the " + this.page + " page ", errors);
    });
  },
  methods:{
    on_click_advert(ad){
      var user = ServerClient.Login.get_logged_in_user();
      ServerClient.Adverts.record_clicked_advert({
        id: ad.id,
        page: this.page,
        section: this.side,
        user_id: user == null ? 0 : user.id,
        views_count: ad.views_count
      },(res)=>{
        //navigate the user away from to new tab
        var ref= 'side_add_'+ad.id;
        //console.log("refs:",this.$refs);
        var t = this.$refs[ref];
        if(t.click){
          t.click();
        }else{
          t[0].click();
        }
      },(errors) => {
        console.log("HomeSideAdsContainer: Error recording the clicked advert ", errors);
      })
    }
  }
};
</script>

<style scoped>
.web-add-container {
  min-width: 300px;
  max-width: 300px;
}

</style>